import Route from '~/providers/Route';
import I18n from '~/i18n';

export const profile = new Route('/perfil', I18n.t('menu-user-profile'), {
  color: 'red',
  root: true,
});

export const changePassword = new Route(
  '/alterar-senha',
  I18n.t('menu-user-change-password'),
  { color: 'red', root: true }
);

export const peoples = new Route('/clientes', I18n.t('menu-peoples'), {
  color: 'red',
  root: true,
  can: 'Peoples',
});

export const showPerson = new Route(
  '/clientes/show/:id',
  I18n.t('person.defSingular'),
  { color: 'blue', parentRoute: peoples }
);

export const editPerson = new Route(
  '/clientes/edit/:id',
  I18n.t('person.defSingular'),
  { color: 'green', parentRoute: peoples }
);

export const examsPerson = new Route(
  '/clientes/exams/:id',
  I18n.t('person.defSingular'),
  { color: 'green', parentRoute: peoples }
);

export const newPerson = new Route(
  '/clientes/new',
  I18n.t('person.defSingular'),
  { color: 'blue', parentRoute: peoples }
);

export const medicalAppointments = new Route(
  '/medical_appointments',
  I18n.t('menu-medical-appointments'),
  { color: 'blue', root: true, can: 'MedicalAppointments' }
);

export const showMedicalAppointments = new Route(
  '/medical_appointments/show/:id',
  I18n.t('medicalAppointments.defSingular'),
  { color: 'blue', parentRoute: medicalAppointments }
);

export const newMedicalAppointments = new Route(
  '/medical_appointments/new',
  I18n.t('medicalAppointments.defSingular'),
  { color: 'blue', parentRoute: medicalAppointments }
);

export const editMedicalAppointments = new Route(
  '/medical_appointments/edit/:id',
  I18n.t('medicalAppointments.defSingular'),
  { color: 'green', parentRoute: medicalAppointments }
);

export const medicalAppointmentsReports = new Route(
  '/medical_appointments_reports',
  I18n.t('menu-medical-appointments-reports'),
  { color: 'blue', root: true, can: 'MedicalAppointmentsReports' }
);

export const dashboards = new Route('/dashboard', I18n.t('menu-dashboard'), {
  color: 'blue',
  root: true,
  can: 'Dashboards',
});

export const coupon = new Route(
  '/coupon', I18n.t('menu-coupon'),
  { color: 'blue', root: true }
);

export const createCoupon = new Route(
  '/coupon/new',
  I18n.t('coupon.extras.create'),
  { parentRoute: coupon, color: 'blue' }
);

export const editCoupon = new Route(
  '/coupon/edit/:id',
  I18n.t('coupon.extras.edit'),
  { parentRoute: coupon, color: 'blue' }
);

export const showCoupon = new Route(
  '/coupon/show/:id',
  I18n.t('coupon.extras.show'),
  { parentRoute: coupon, color: 'blue' }
);

export const chats = new Route('/chats', I18n.t('menu-chats'), {
  color: 'blue',
  root: true,
  can: 'Chats',
});

export const createChat = new Route(
  '/chats/new',
  I18n.t('chats.extras.create'),
  { parentRoute: chats, color: 'blue' }
);

export const editChat = new Route(
  '/chats/edit/:id',
  I18n.t('chats.extras.edit'),
  { parentRoute: chats, color: 'blue' }
);

export const schedules = new Route('/schedules', I18n.t('menu-schedules'), {
  color: 'blue',
  root: true,
  can: 'Schedules',
});

export const createDoctorSchedule = new Route(
  '/schedules/new',
  I18n.t('doctor_schedules.extras.create'),
  { parentRoute: schedules, color: 'blue' }
);

export const showDoctorSchedule = new Route(
  '/schedules/show/:id',
  I18n.t('doctor_schedules.extras.show'),
  { parentRoute: schedules, color: 'blue' }
);

export const editDoctorSchedule = new Route(
  '/schedules/edit/:id',
  I18n.t('doctor_schedules.extras.edit'),
  { parentRoute: schedules, color: 'blue' }
);

// specialties
export const specialties = new Route(
  '/specialties',
  I18n.t('menu-specialties'),
  { color: 'blue', root: true, can: 'Specialties' }
);

export const createSpecialty = new Route(
  '/specialties/new',
  I18n.t('specialties.extras.create'),
  { parentRoute: specialties, color: 'blue' }
);

export const showSpecialty = new Route(
  '/specialties/show/:id',
  I18n.t('specialties.extras.show'),
  { parentRoute: specialties, color: 'blue' }
);

export const editSpecialty = new Route(
  '/specialties/edit/:id',
  I18n.t('specialties.extras.edit'),
  { parentRoute: specialties, color: 'blue' }
);

// files
export const files = new Route('/files', I18n.t('menu-files'), {
  color: 'blue',
  root: true,
  can: 'Files',
});

export const createFile = new Route(
  '/files/new',
  I18n.t('files.extras.create'),
  { parentRoute: files, color: 'blue' }
);

export const showFile = new Route(
  '/files/show/:id',
  I18n.t('files.extras.show'),
  { parentRoute: files, color: 'blue' }
);

export const editFile = new Route(
  '/files/edit/:id',
  I18n.t('files.extras.edit'),
  { parentRoute: files, color: 'blue' }
);

// medical appointments
export const showMedicalAppointmentsReports = new Route(
  '/medical_appointments_reports/show/:id',
  I18n.t('medicalAppointments.defSingular'),
  { color: 'blue', parentRoute: medicalAppointmentsReports }
);

export const editMedicalAppointmentsReports = new Route(
  '/medical_appointments_reports/edit/:id',
  I18n.t('medicalAppointments.defSingular'),
  { color: 'green', parentRoute: medicalAppointmentsReports }
);

export const showEvent = new Route(
  '/clientes/:id/event/:event_id',
  I18n.t('person.defRoutes'),
  { color: 'blue', parentRoute: peoples }
);

export const sendPush = new Route('/enviar-push', I18n.t('menu-send-push'), {
  color: 'blue',
  root: true,
  can: 'Pushs',
});

export const createPush = new Route(
  '/enviar-push/new',
  I18n.t('push.extras.create_push'),
  { parentRoute: sendPush, color: 'blue' }
);

export const showPush = new Route(
  '/enviar-push/show/:id',
  I18n.t('push.extras.show_push'),
  { parentRoute: sendPush, color: 'blue' }
);

export const editPush = new Route(
  '/enviar-push/edit/:id',
  I18n.t('push.extras.edit_push'),
  { parentRoute: sendPush, color: 'blue' }
);

export const cards = new Route('/cards', I18n.t('menu-cards'), {
  color: 'red',
  root: true,
  can: 'Cards',
});

export const createCards = new Route('/cards/new', I18n.t('menu-cards'), {
  parentRoute: cards,
  color: 'blue',
});

export const showCards = new Route('/cards/show/:id', I18n.t('menu-cards'), {
  parentRoute: cards,
  color: 'blue',
});

export const editCards = new Route('/cards/edit/:id', I18n.t('menu-cards'), {
  parentRoute: cards,
  color: 'blue',
});

export const subscription = new Route(
  '/assinatura',
  I18n.t('menu-subscription'),
  { color: 'blue', root: true, can: 'Subscriptions' }
);

export const createSubscription = new Route(
  '/assinatura/new',
  I18n.t('subscription.extras.new'),
  { parentRoute: subscription, color: 'blue' }
);

export const showSubscription = new Route(
  '/assinatura/show/:id',
  I18n.t('subscription.extras.show'),
  { parentRoute: subscription, color: 'blue' }
);

export const editSubscription = new Route(
  '/assinatura/edit/:id',
  I18n.t('subscription.extras.edit'),
  { parentRoute: subscription, color: 'blue' }
);

export const faq = new Route('/faq', I18n.t('menu-faq'), {
  color: 'red',
  root: true,
  can: 'Faqs',
});

export const folders = new Route('/faq/folder/:id', I18n.t('menu-faq'), {
  parentRoute: faq,
  color: 'red',
});

export const reportPeoples = new Route(
  '/relatorios/clientes',
  I18n.t('menu-report-peoples'),
  { color: 'red', root: true }
);

export const images = new Route('/imagens', I18n.t('menu-images'), {
  color: 'red',
  root: true,
});

export const tourImage = new Route('/tourImage', I18n.t('menu-images'), {
  color: 'red',
  root: true,
  can: 'TourImages',
});

export const newTourImage = new Route('/tourImage/new', I18n.t('menu-images'), {
  parentRoute: tourImage,
  color: 'red',
});
export const editTourImage = new Route(
  '/tourImage/edit/:id',
  I18n.t('menu-images'),
  { parentRoute: tourImage, color: 'red' }
);
export const showTourImage = new Route(
  '/tourImage/show/:id',
  I18n.t('menu-images'),
  { parentRoute: tourImage, color: 'red' }
);

export const addon = new Route('/adicionais', I18n.t('menu-addon'), {
  color: 'green',
  root: true,
  can: 'Addons',
});

export const createAddon = new Route(
  '/adicionais/new',
  I18n.t('addon.extras.create_addon'),
  { parentRoute: addon, color: 'green' }
);

export const showAddon = new Route(
  '/adicionais/show/:id',
  I18n.t('addon.extras.show_addon'),
  { parentRoute: addon, color: 'green' }
);

export const editAddon = new Route(
  '/adicionais/edit/:id',
  I18n.t('addon.extras.edit_addon'),
  { parentRoute: addon, color: 'green' }
);

export const partner = new Route('/partner', I18n.t('menu-partner'), {
  color: 'orange',
  root: true,
  can: 'Partners',
});

export const showPartner = new Route(
  '/partner/show/:id',
  I18n.t('partner.extras.show_partner'),
  { parentRoute: partner, color: 'orange' }
);

export const editPartner = new Route(
  '/partner/edit/:id',
  I18n.t('partner.extras.edit_partner'),
  { parentRoute: partner, color: 'blue' }
);

export const createPartner = new Route(
  '/partner/new',
  I18n.t('partner.extras.create_partner'),
  { parentRoute: partner, color: 'blue' }
);

export const corporation = new Route(
  '/corporation',
  I18n.t('menu-corporation'),
  { color: 'orange', root: true, can: 'Corporations' }
);

export const showCorporation = new Route(
  '/corporation/show/:id',
  I18n.t('corporation.extras.show_corporation'),
  { parentRoute: corporation, color: 'orange' }
);

export const editCorporation = new Route(
  '/corporation/edit/:id',
  I18n.t('corporation.extras.edit_corporation'),
  { parentRoute: corporation, color: 'blue' }
);

export const createCorporation = new Route(
  '/corporation/new',
  I18n.t('corporation.extras.create_corporation'),
  { parentRoute: corporation, color: 'blue' }
);

export const login = new Route('/');

export const packageBillings = new Route(
  '/compra_adicionais',
  I18n.t('menu-package-billings'),
  { color: 'orange', root: true, can: 'PackageBillings' }
);
export const showPackageBilling = new Route(
  '/compra_adicionais/:id',
  I18n.t('packageBilling.extras.show_billing'),
  { parentRoute: packageBillings, color: 'green' }
);

export const planBillings = new Route(
  '/compra_assinaturas',
  I18n.t('menu-plan-billings'),
  { color: 'orange', root: true, can: 'PlanBillings' }
);
export const showPlanBilling = new Route(
  '/compra_assinaturas/:id',
  I18n.t('planBilling.extras.show_billing'),
  { parentRoute: planBillings, color: 'green' }
);

export const partnersDashboard = new Route(
  '/partners_dashboard',
  'Assinaturas',
  { color: 'blue', root: true }
);

export const appointmentCategories = new Route(
  '/appointment_categories',
  I18n.t('menu-appointment-categories'),
  { color: 'blue', root: true, can: 'AppointmentCategories' }
);

export const showAppointmentCategories = new Route(
  '/appointment_categories/show/:id',
  I18n.t('appointmentCategories.extras.show_appointment_category'),
  { color: 'blue', parentRoute: appointmentCategories }
);

export const newAppointmentCategories = new Route(
  '/appointment_categories/new',
  I18n.t('appointmentCategories.extras.create_appointment_category'),
  { color: 'blue', parentRoute: appointmentCategories }
);

export const editAppointmentCategories = new Route(
  '/appointment_categories/edit/:id',
  I18n.t('appointmentCategories.extras.edit_appointment_category'),
  { color: 'green', parentRoute: appointmentCategories }
);

export const appointmentTags = new Route(
  '/appointment_tags',
  I18n.t('menu-appointment-tags'),
  { color: 'blue', root: true, can: 'AppointmentTags' }
);

export const showAppointmentTags = new Route(
  '/appointment_tags/show/:id',
  I18n.t('appointmentTags.extras.show_appointment_tag'),
  { color: 'blue', parentRoute: appointmentTags }
);

export const newAppointmentTags = new Route(
  '/appointment_tags/new',
  I18n.t('appointmentTags.extras.create_appointment_tag'),
  { color: 'blue', parentRoute: appointmentTags }
);

export const editAppointmentTags = new Route(
  '/appointment_tags/edit/:id',
  I18n.t('appointmentTags.extras.edit_appointment_tag'),
  { color: 'green', parentRoute: appointmentTags }
);

export const packs = new Route('/packs', I18n.t('menu-packs'), {
  color: 'blue',
  root: true,
  can: 'Packs',
});

export const createPack = new Route(
  '/packs/new',
  I18n.t('packs.extras.create'),
  { parentRoute: packs, color: 'blue' }
);

export const showPack = new Route(
  '/packs/show/:id',
  I18n.t('packs.extras.show'),
  { parentRoute: packs, color: 'blue' }
);

export const editPack = new Route(
  '/packs/edit/:id',
  I18n.t('packs.extras.edit'),
  { parentRoute: packs, color: 'blue' }
);

export const products = new Route('/products', I18n.t('menu-products'), {
  color: 'blue',
  root: true,
  can: 'Products',
});

export const createProduct = new Route(
  '/products/new',
  I18n.t('products.extras.create'),
  { parentRoute: products, color: 'blue' }
);

export const showProduct = new Route(
  '/products/show/:id',
  I18n.t('products.extras.show'),
  { parentRoute: products, color: 'blue' }
);

export const editProduct = new Route(
  '/products/edit/:id',
  I18n.t('products.extras.edit'),
  { parentRoute: products, color: 'blue' }
);

export const pins = new Route('/pins', I18n.t('menu-pins'), {
  color: 'blue',
  root: true,
  can: 'Pins',
});

export const createPin = new Route('/pins/new', I18n.t('pins.extras.create'), {
  parentRoute: pins,
  color: 'blue',
});

export const showPin = new Route('/pins/show/:id', I18n.t('pins.extras.show'), {
  parentRoute: pins,
  color: 'blue',
});

export const epayTransactions = new Route(
  '/epay_transactions',
  I18n.t('menu-epay-transactions'),
  { color: 'blue', root: true, can: 'EpayTransactions' }
);

export const showEpayTransaction = new Route(
  '/epay_transactions/show/:id',
  I18n.t('epayTransactions.extras.show'),
  { parentRoute: epayTransactions, color: 'blue' }
);

export const reports = new Route('/reports', I18n.t('menu-reports'), {
  color: 'blue',
  root: true,
  can: 'Reports',
});

export const reportUsersActives = new Route(
  '/reports/users_actives',
  I18n.t('dashboard.attributes.users_by_month'),
  { color: 'blue', root: true, can: 'Reports' }
);

export const reportPackagesActives = new Route(
  '/reports/packages_actives',
  I18n.t('dashboard.attributes.packages_by_month'),
  { color: 'blue', root: true, can: 'Reports' }
);

export const reportPackagesEspecialtyActives = new Route(
  '/reports/packages_especialty_actives',
  I18n.t('dashboard.attributes.packages_specialty_by_month'),
  { color: 'blue', root: true, can: 'Reports' }
);

export const reportStation = new Route(
  '/reports/station',
  I18n.t('stationReport.title'),
  { color: 'blue', root: true, can: 'Reports' }
);

export const sales = new Route(
  '/reports/sales',
  I18n.t('dashboard.attributes.sales'),
  { color: 'blue', root: true, can: 'Reports' }
);

export const SIDMedicalAppointmentsReports = new Route(
  '/reports/SIDMedicalAppointmentsReports',
  I18n.t('dashboard.attributes.SIDMedicalAppointmentsReports'),
  { color: 'blue', root: true, can: 'Reports' }
);

export const accidentReports = new Route(
  '/reports/accident_reports',
  I18n.t('dashboard.attributes.accident_reports'),
  { color: 'blue', root: true, can: 'Reports' }
);

export const appointmentRating = new Route(
  '/reports/appointment_rating',
  I18n.t('dashboard.attributes.appointment_rating'),
  { color: 'blue', root: true, can: 'Reports' }
);

export const logsReports = new Route(
  '/reports/logs_reports',
  I18n.t('dashboard.attributes.logs_reports'),
  { color: 'blue', root: true, can: 'Reports' }
);

export const activeClients = new Route(
  '/reports/active_clients',
  I18n.t('dashboard.attributes.active_clients'),
  { color: 'blue', root: true, can: 'Reports' }
);

export const reportIdsIntegration = new Route(
  '/reports/ids_integration',
  I18n.t('dashboard.attributes.ids_integration'),
  { color: 'blue', root: true, can: 'Reports' }
);

export const reportMevoPrescricoes = new Route(
  '/reports/mevo_prescricoes',
  'Receitas Mevo',
  { color: 'blue', root: true, can: 'Reports' }
);

export const showLog = new Route(
  '/logs/show/:id',
  I18n.t('dashboard.attributes.show_log'),
  { color: 'blue', root: true, can: 'Reports' }
);

export const pendingFiles = new Route(
  '/pending_files',
  I18n.t('menu-pending-files'),
  { color: 'blue', root: true, can: 'PendingFiles' }
);

export const whatsappCampaign = new Route(
  '/whatsapp-campaign',
  I18n.t('menu-whatsapp-campaign'),
  { color: 'green', root: true, can: 'WhatsappCampaign' }
);
export const appointmentConfirmations = new Route(
  '/appointment-confirmations',
  I18n.t('menu-appointment-confirmations'),
  { color: 'green', root: true, can: 'AppointmentConfirmations' }
);
export const preRegistrationCampaign = new Route(
  '/pre-registration-campaign',
  I18n.t('menu-pre-registration-campaign'),
  { color: 'green', root: true, can: 'WhatsappCampaign' }
);
export const infobipAccess = new Route(
  '/infobip-access',
  I18n.t('menu-infobip-access'),
  { color: 'green', root: true, can: 'WhatsappCampaign' }
);
export const whatsappCampaignInvitations = new Route(
  '/whatsapp-campaign/invitations',
  I18n.t('whatsappCampaign.extras.invitations'),
  { parentRoute: whatsappCampaign, color: 'green' }
);
